'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

export function AssessmentBlackScreenAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('./raw-json/assessment-instructions-black-screen-animation.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="AssessmentBlackScreenAnimation"
    />
  );
}
